const PrivacyPolicy = () => {
	return (
		<main className="mt-25 max-w-5xl px-6 py-12 md:mt-40">
			<h1 className="mb-10 font-serif text-4xl leading-[1.2] text-white uppercase md:text-5xl">Privacy Policy</h1>
			<div className="flex flex-col gap-4 text-sm text-white md:text-base">
				<p>
					Birrificio San Giorgio S.r.l. fa parte del gruppo di società Royal Unibrew con sede in Royal Unibrew A/S, Faxe
					Allé 1, 4640 Faxe, Danimarca (il &quot;Gruppo&quot;).
				</p>
				<h2 className="text-2xl font-bold uppercase md:text-3xl">Informativa sulla privacy</h2>
				<p>
					Quando ci riferiamo a “noi”, “ci” o “nostro” nella presente informativa sulla privacy, ci riferiamo alla
					società del Gruppo responsabile del trattamento dei dati dell’utente. Puoi trovare un elenco di tutte le
					aziende e sedi di Royal Unibrew qui:{" "}
					<a
						href="https://www.royalunibrew.com/about-us/company-structure"
						target="_blank"
						rel="noopener noreferrer"
						className="underline">
						https://www.royalunibrew.com/about-us/company-structure
					</a>
					. La presente informativa sulla privacy si applica a tutte le società del Gruppo.
				</p>
				<p>
					Il titolare del trattamento dei dati personali dell’utente è la società del Gruppo Royal Unibrew con cui
					interagisce. Se non sei sicuro dell’azienda con cui stai interagendo, puoi contattarci al{" "}
					<a href="mailto:GDPR@Royalunibrew.com" target="_blank" rel="noopener noreferrer" className="underline">
						GDPR@Royalunibrew.com
					</a>
					. <br />
					In questa informativa sulla privacy puoi leggere come trattiamo le tue informazioni. <br />
					La presente informativa sulla privacy si applica a chiunque acquisti prodotti o servizi da noi, sia un
					fornitore o un partner commerciale, visiti uno dei nostri indirizzi fisici, sia un candidato a un posto di
					lavoro, partecipi a uno dei nostri eventi o a un concorso o interagisca in altro modo con noi, ad esempio
					quando utilizza uno dei nostri siti Web o comunica con noi tramite i social media o un’altra piattaforma.
				</p>
				<h3 className="text-xl font-bold uppercase md:text-2xl">Come trattiamo i tuoi dati personali</h3>
				<p>
					Il trattamento dei tuoi dati dipende dal contesto in cui interagisci con noi. <br />
					Di seguito puoi leggere di più sulle attività in cui trattiamo le tue informazioni. Di seguito specifichiamo a
					chi si riferiscono le informazioni, quali tipi di informazioni trattiamo, la base giuridica e per quanto tempo
					conserviamo le informazioni. <br />
					In questa informativa, puoi anche leggere di più su con chi potremmo condividere le informazioni. <br />
					Si prega di notare che possiamo trattare le informazioni per diversi scopi se l’utente interagisce con noi in
					diversi modi, ad esempio, se è un nostro cliente e visita una delle nostre sedi fisiche.
				</p>
				<h3 className="text-xl font-bold uppercase md:text-2xl">
					Se l&apos;utente ci contatta, inclusa la presentazione di un reclamo
				</h3>
				<p>
					Il titolare del trattamento dei dati personali dell’utente è la società del Gruppo Royal Unibrew con la quale
					l’utente è in corrispondenza. In caso di dubbi sulla società Royal Unibrew Group con cui corri, è possibile
					contattarci al{" "}
					<a href="mailto:GDPR@Royalunibrew.com" target="_blank" rel="noopener noreferrer" className="underline">
						GDPR@Royalunibrew.com
					</a>
					. <br />
					Lo scopo del trattamento delle tue informazioni, se ci contatti come consumatore o se ti lamenti di uno dei
					nostri prodotti o di un’esperienza con noi, è che possiamo elaborare la tua richiesta e assicurarci che tu
					riceva una risposta da noi. <br />
					La nostra base giuridica per il trattamento delle informazioni dell’utente nelle situazioni di cui sopra è il
					nostro legittimo interesse a elaborare la richiesta dell’utente e a garantire che eventuali reclami, compresi
					i reclami relativi ai nostri prodotti, siano esaminati e gestiti, cfr. articolo 6, paragrafo 1, lettera f) del
					Regolamento generale sulla protezione dei dati. <br />
					Chiediamo di non ricevere informazioni che rientrano nella categoria speciale di dati, cfr. articolo 9,
					paragrafo 1, del Regolamento generale sulla protezione dei dati, compresi i dati sanitari, le informazioni
					sulle convinzioni religiose o l’appartenenza sindacale. Se comunque ci fornisci tali informazioni, presumiamo
					che tu abbia dato il tuo consenso esplicito al trattamento e quindi trattiamo queste informazioni sulla base
					del tuo consenso, cfr. articolo 6, paragrafo 1, lettera a) e articolo 9, paragrafo 2, lettera a) del
					Regolamento generale sulla protezione dei dati.
				</p>
				<h4 className="text-base underline md:text-lg">Le informazioni che trattiamo</h4>
				<p>Potremmo trattare le seguenti informazioni su di te in qualità di consumatore o reclamante:</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>
						Informazioni di contatto: ad es. nome, indirizzo, e-mail, numero di telefono, codice postale, numero
						cliente, iniziali
					</li>
					<li>Informazioni relative al lavoro: ad es. titolo, posizione, luogo di lavoro</li>
					<li>Altre informazioni che l’utente stesso ci fornisce quando ci contatta </li>
					<li>
						Categorie particolari di dati, ad esempio dati relativi alla salute, alla religione o all’appartenenza
						sindacale, se forniti dall’utente nell’ambito della sua richiesta.
					</li>
				</ul>
				<h4 className="text-base underline md:text-lg">Conservazione delle informazioni dell’utente</h4>
				<p>
					Non conserviamo le informazioni più a lungo di quanto sia necessario per soddisfare lo scopo. Il periodo
					durante il quale conserviamo le informazioni dell’utente sarà determinato in modo specifico a seconda del caso
					in cui le informazioni sono incluse. Cancelliamo le tue informazioni non appena il tuo caso è stato elaborato,
					a meno che non abbiamo bisogno di essere in grado di documentare la corrispondenza/reclamo per un periodo più
					lungo.
				</p>
				<h3 className="text-xl font-bold uppercase md:text-2xl">Se sei un fornitore o un partner commerciale</h3>
				<p>
					Lo scopo del trattamento dei vostri dati in qualità di fornitore o partner commerciale è quello di poter
					gestire il rapporto commerciale o di cooperazione in corso, compresa la gestione del contratto, e di garantire
					una comunicazione efficace con voi.
				</p>
				<p>
					Se l&apos;utente è una parte diretta del contratto (ad es. se è una ditta individuale), la nostra base
					giuridica per il trattamento dei dati è che possiamo eseguire un contratto con l&apos;utente in qualità di
					fornitore o partner, cfr. articolo 6, paragrafo 1, lettera b) del Regolamento generale sulla protezione dei
					dati. In altri casi, trattiamo i vostri dati personali sulla base del nostro legittimo interesse a
					salvaguardare i nostri diritti e obblighi derivanti dagli accordi ecc. che abbiamo stipulato con
					l&apos;azienda da cui lavorate, cfr. articolo 6, paragrafo 1, lettera f) del Regolamento generale sulla
					protezione dei dati.
				</p>
				<p>Inoltre, trattiamo le tue informazioni per:</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>
						garantire la qualità e controllare la nostra catena di approvvigionamento, anche per garantire il rispetto
						dei diritti fondamentali e la lotta alla criminalità.
					</li>
					<li>analisi e reportistica interna e formazione dei nostri dipendenti e consulenti</li>
				</ul>
				<p>
					La nostra base giuridica per questo trattamento è il perseguimento del nostro legittimo interesse per le
					finalità di cui sopra, cfr. articolo 6, paragrafo 1, lettera f) del Regolamento generale sulla protezione dei
					dati. In questo contesto, registriamo la nostra corrispondenza con voi per la documentazione necessaria a
					soddisfare gli scopi.
				</p>
				<h4 className="text-base underline md:text-lg">Le informazioni che trattiamo</h4>
				<p>Possiamo trattare le seguenti informazioni su di te in qualità di fornitore o partner:</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>
						Informazioni di contatto: ad es. nome, indirizzo, e-mail, numero di telefono, codice postale, numero
						cliente, iniziali
					</li>
					<li>Informazioni relative al lavoro: ad es. titolo, posizione, luogo di lavoro </li>
					<li>Informazioni finanziarie, come termini di pagamento, coordinate bancarie e solvibilità</li>
					<li>
						Informazioni relative all&apos;IT, come l&apos;ID utente, i dettagli di accesso e i dati e i log relativi
						all&apos;utilizzo dei nostri siti web da parte dell&apos;utente
					</li>
				</ul>
				<h4 className="text-base underline md:text-lg">Conservazione delle informazioni dell&apos;utente</h4>
				<p>
					Conserviamo le informazioni dell&apos;utente per tutto il tempo in cui abbiamo un rapporto commerciale e per
					un periodo successivo alla fine del rapporto commerciale per rispettare la legislazione applicabile, compresa
					la legislazione sulla contabilità nei paesi in cui operiamo. Tuttavia, le informazioni possono essere
					elaborate e conservate più a lungo in forma anonima.
				</p>
				<h3 className="text-xl font-bold uppercase md:text-2xl">Se sei un cliente o un potenziale cliente</h3>
				<p>
					Lo scopo del trattamento delle informazioni dell&apos;utente quando è un cliente o un potenziale cliente
					(consumatore o aziendale), anche quando fa acquisti nei nostri negozi online, è quello di poter adempiere agli
					accordi con l&apos;utente, inclusa la garanzia dell&apos;esecuzione, della consegna o dell&apos;annullamento
					di un ordine e dei servizi ad esso correlati.
				</p>
				<p>
					Se l&apos;utente è una parte diretta del contratto (ad esempio, se si tratta di un&apos;impresa individuale),
					la nostra base giuridica per il trattamento dei dati è la stipula o l&apos;esecuzione di un contratto con
					l&apos;utente in qualità di cliente o potenziale cliente in relazione alla stipula di un contratto, cfr.
					articolo 6, paragrafo 1, lettera b) del Regolamento generale sulla protezione dei dati. In altri casi,
					trattiamo i dati personali dell&apos;utente sulla base del nostro legittimo interesse a salvaguardare i nostri
					diritti e obblighi derivanti dagli accordi stipulati con l&apos;azienda da cui l&apos;utente è dipendente,
					cfr. articolo 6, paragrafo 1, lettera f) del Regolamento generale sulla protezione dei dati.
				</p>
				<p>Inoltre, trattiamo le informazioni dell&apos;utente in relazione a:</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>Assistenza clienti e comunicazioni generali </li>
					<li>Garanzia di qualità dei nostri prodotti e servizi </li>
					<li>Sviluppo di prodotti e servizi </li>
					<li>Rating del credito</li>
					<li>analisi e reportistica interna e formazione dei nostri dipendenti e consulenti</li>
				</ul>
				<p>
					La nostra base giuridica per questo trattamento è fondamentalmente la possibilità di perseguire il nostro
					legittimo interesse per le finalità di cui sopra, cfr. articolo 6, paragrafo 1, lettera f) del Regolamento
					generale sulla protezione dei dati.
				</p>
				<p>
					Il trattamento può essere necessario anche per l&apos;accertamento, l&apos;esercizio o la difesa di un diritto
					in sede giudiziaria, cfr. articolo 6, paragrafo 1, lettera f), e articolo 9, paragrafo 2, lettera f), del
					regolamento generale sulla protezione dei dati.
				</p>
				<h4 className="text-base underline md:text-lg">Le informazioni che trattiamo: </h4>
				<p>Possiamo trattare le seguenti informazioni su di te come cliente o potenziale cliente:</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>
						Informazioni di contatto: ad es. nome, indirizzo, e-mail, numero di telefono, codice postale, numero
						cliente, iniziali
					</li>
					<li>Informazioni relative al lavoro: ad es. titolo, posizione, luogo di lavoro </li>
					<li>Informazioni finanziarie, come termini di pagamento, coordinate bancarie e solvibilità</li>
					<li>
						Informazioni relative all&apos;IT, come l&apos;ID utente, i dettagli di accesso e i dati e i log relativi
						all&apos;utilizzo dei nostri siti web da parte dell&apos;utente
					</li>
					<li>Foto o video di te </li>
				</ul>
				<h4 className="text-base underline md:text-lg">Conservazione delle informazioni dell&apos;utente</h4>
				<p>
					Conserviamo le informazioni dell&apos;utente per tutto il tempo in cui abbiamo un rapporto commerciale e per
					un periodo successivo alla fine della collaborazione per rispettare la legislazione applicabile, compresa la
					legislazione sulla contabilità nei paesi in cui operiamo. Tuttavia, le informazioni possono essere elaborate e
					conservate più a lungo in forma anonima.
				</p>
				<h3 className="text-xl font-bold uppercase md:text-2xl">
					Se visiti i nostri siti web o utilizzi le nostre app{" "}
				</h3>
				<p>
					I dati personali dell&apos;utente saranno raccolti attraverso i nostri siti web e le nostre app in uno o più
					dei seguenti casi:
				</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>Quando visiti e navighi sui nostri siti web e sulle nostre app</li>
					<li>Quando si crea un profilo utente</li>
					<li>Quando l&apos;utente scarica materiale dai nostri siti web e dalle nostre app</li>
					<li>Quando l&apos;utente utilizza le nostre altre funzionalità e servizi</li>
				</ul>
				<p>
					Inoltre, raccoglieremo i tuoi dati personali tramite i nostri siti web e le nostre app quando comunichi con
					noi, ad esempio inviando una richiesta tramite un modulo di contatto, quando ti iscrivi alla nostra
					newsletter, quando partecipi ai nostri concorsi o utilizzi altri servizi e funzionalità attraverso i nostri
					siti web. Queste operazioni di trattamento sono descritte in sezioni separate dell&apos;informativa sulla
					privacy.
				</p>
				<p>Lo scopo del trattamento dei tuoi dati quando visiti i nostri siti web o quando utilizzi le nostre app è:</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>che possiamo gestire gli account e i profili degli utenti</li>
					<li>
						che possiamo sviluppare, migliorare e amministrare queste piattaforme, inclusa la garanzia che i contenuti
						siano pertinenti e presentati nel modo più efficace sul dispositivo dell&apos;utente
					</li>
					<li>
						per garantire che l&apos;utente possa partecipare/registrarsi in relazione alle nostre funzioni interattive
						e alle nostre offerte{" "}
					</li>
					<li>per analizzare il traffico sui nostri siti web e app</li>
				</ul>
				<p>
					La nostra base giuridica per il trattamento dei dati dell&apos;utente è il nostro legittimo interesse per le
					finalità di cui sopra, cfr. articolo 6, paragrafo 1, lettera f) del Regolamento generale sulla protezione dei
					dati, o il consenso dell&apos;utente, che otteniamo se richiesto dalla legge, cfr. articolo 6, paragrafo 1,
					lettera a) del Regolamento generale sulla protezione dei dati, ad esempio in relazione all&apos;uso dei
					cookie. Per saperne di più sull&apos;uso dei cookie, consulta la sezione seguente.
				</p>
				<p>
					Siamo inoltre obbligati a garantire il rispetto della legislazione sulla commercializzazione dei nostri
					prodotti, secondo la quale solo le persone di una certa età possono acquistare legalmente i nostri prodotti e
					ricevere la commercializzazione dei nostri prodotti, in particolare per quanto riguarda i prodotti contenenti
					alcol. Pertanto, trattiamo le informazioni a tale scopo e la nostra base giuridica per il trattamento di
					queste informazioni è costituita dai nostri obblighi legali di rispettare la legislazione sull&apos;acquisto e
					la commercializzazione dei nostri prodotti, cfr. articolo 6, paragrafo 1, lettera c) del Regolamento generale
					sulla protezione dei dati.
				</p>
				<p>
					Infine, possiamo anche trattare le informazioni che l&apos;utente ha manifestamente reso pubbliche, cfr.
					l&apos;articolo 6, paragrafo 1, lettera f), e l&apos;articolo 9, paragrafo 2, lettera e), del Regolamento
					generale sulla protezione dei dati.
				</p>
				<h4 className="text-base underline md:text-lg">Le informazioni che trattiamo:</h4>
				<p>Possiamo trattare le seguenti informazioni su di te come visitatore di uno dei nostri siti web o app:</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>
						Informazioni di contatto: ad es. nome, indirizzo, e-mail, numero di telefono, codice postale, numero
						cliente, iniziali{" "}
					</li>
					<li>Foto o video </li>
					<li>Informazioni personali: ad es. età</li>
					<li>Altre informazioni che hai pubblicato tu stesso </li>
					<li>Cookies </li>
				</ul>
				<h4 className="text-base underline md:text-lg">Conservazione delle informazioni dell&apos;utente</h4>
				<p>
					Le informazioni elaborate nelle nostre app vengono conservate per tutto il tempo in cui il profilo
					dell&apos;utente è attivo, ma potremmo conservare le informazioni per un periodo più lungo se richiesto dalle
					leggi dei paesi in cui operiamo. Per i periodi di conservazione dei cookie, si prega di fare riferimento alla
					sezione sui cookie di seguito.
				</p>
				<h3 className="text-xl font-bold uppercase md:text-2xl">Se visiti i nostri profili sui social media</h3>
				<p>
					Noi e i fornitori della rispettiva piattaforma di social media siamo contitolari del trattamento dei dati
					personali raccolti in relazione alla vostra visita al nostro profilo o alla nostra pagina sulla singola
					piattaforma di social media.
				</p>
				<p>
					Abbiamo profili o pagine su vari social media (piattaforme). Puoi personalizzare le tue impostazioni sulla
					privacy individualmente su ciascuna piattaforma. Facciamo riferimento alle informative sulla privacy del
					fornitore e alle impostazioni per l&apos;utilizzo della piattaforma.
				</p>
				<p>
					Puoi anche contattarci se hai domande sulla responsabilità congiunta dei dati e sul trattamento delle tue
					informazioni sui social media.
				</p>
				<h4 className="text-base underline md:text-lg">Le informazioni che trattiamo:</h4>
				<p>
					Quando l&apos;utente visita o interagisce con i nostri profili sui social media, noi e il fornitore della
					piattaforma di social media possiamo raccogliere, elaborare e archiviare i seguenti tipi di dati personali che
					lo riguardano:
				</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>
						Informazioni disponibili sul tuo profilo, tra cui nome, sesso, stato civile, luogo di lavoro, interessi e
						città
					</li>
					<li>Se l&apos;utente ha messo &quot;mi piace&quot; o se ha utilizzato altre reazioni al nostro profilo</li>
					<li>Commenti che lasci sui nostri post, anche in relazione a concorsi</li>
					<li>Che hai visitato il nostro profilo</li>
				</ul>
				<h4 className="text-base underline md:text-lg">Finalità del trattamento</h4>
				<p>Trattiamo i tuoi dati personali per le seguenti finalità:</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>Migliorare i nostri prodotti e servizi, compresi i nostri profili e le nostre pagine sui social media</li>
					<li>Statistiche e analisi</li>
					<li>Per comunicare con te se commenti un post, lasci una recensione o ci invii un messaggio</li>
					<li>Marketing in generale, compresa l&apos;organizzazione di concorsi </li>
				</ul>
				<p>
					I fornitori di social media trattano, tra l&apos;altro, i dati personali dell&apos;utente per le seguenti
					finalità:
				</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>Migliorare il proprio sistema pubblicitario </li>
					<li>
						Per fornirci statistiche che i fornitori di social media compilano sulla base, tra le altre cose, della
						visita dell&apos;utente ai nostri profili e alle nostre pagine
					</li>
					<li>Pubblicità e personalizzazione delle attività sul Sito </li>
				</ul>
				<p>
					La nostra base giuridica per il trattamento delle informazioni dell&apos;utente è il nostro legittimo
					interesse a poter comunicare con l&apos;utente e commercializzarci sui nostri profili di social media, nonché
					il nostro legittimo interesse a migliorare i nostri prodotti e servizi, cfr. articolo 6, paragrafo 1, lettera
					f) del Regolamento generale sulla protezione dei dati.
				</p>
				<p>
					I fornitori di social media basano il trattamento dei dati personali dell&apos;utente sui loro legittimi
					interessi, incluso il loro interesse a migliorare il loro sistema pubblicitario e a fornirci statistiche che
					il fornitore di social media, ad esempio, compila in base alla visita dell&apos;utente al nostro profilo o
					alla nostra pagina di social media.
				</p>
				<p>
					Inoltre, i fornitori di social media hanno un interesse legittimo a fornire un servizio innovativo, adattato
					individualmente, sicuro ed economicamente vantaggioso, cfr. articolo 6, paragrafo 1, lettera f), del
					regolamento generale sulla protezione dei dati. I fornitori di social media trattano alcuni dei tuoi dati
					personali in conformità con il tuo consenso, che puoi revocare in qualsiasi momento tramite le tue
					impostazioni sulla privacy sui social media, cfr. articolo 6, paragrafo 1, lettera a) del regolamento generale
					sulla protezione dei dati.
				</p>
				<h4 className="text-base underline md:text-lg">Conservazione delle informazioni dell&apos;utente</h4>
				<p>
					Ti invitiamo a eliminare commenti, Mi piace e altre interazioni che hai lasciato sul nostro profilo se non
					desideri più che appaiano sulle nostre pagine. Non cancelliamo tali interazioni disponibili pubblicamente.
				</p>
				<p>
					Se l&apos;utente comunica con noi tramite la funzione di messaggistica dei social media, cancelleremo i
					messaggi quando lo richiederà.
				</p>
				<p>
					Si prega di fare riferimento all&apos;informativa sulla privacy dei singoli fornitori di social media per
					informazioni sulla durata di conservazione dei dati personali.
				</p>
				<p>
					I fornitori di piattaforme di social media possono condividere i dati personali dell&apos;utente con le
					seguenti categorie di destinatari:
				</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>Altre entità all&apos;interno del gruppo di società di cui fa parte il fornitore di social media</li>
					<li>Esternamente con partner commerciali che forniscono servizi di analisi e sondaggi</li>
					<li>Inserzionisti</li>
					<li>
						Altre persone che visitano il nostro profilo o la nostra pagina sui social media (nella misura in cui le tue
						informazioni sono disponibili pubblicamente)
					</li>
					<li>Ricercatori e altri accademici</li>
				</ul>
				<p>
					Puoi trovare maggiori informazioni su chi i fornitori di social media condividono i tuoi dati personali
					nell&apos;informativa sulla privacy dei singoli fornitori, inclusi i casi in cui i fornitori di social media
					possono trasferire i tuoi dati personali a destinatari al di fuori dell&apos;UE/SEE.
				</p>
				<h3 className="text-xl font-bold uppercase md:text-2xl">Se partecipi ad uno dei nostri eventi </h3>
				<p>
					Se partecipi a uno dei nostri eventi, inclusi gli eventi da noi sponsorizzati, lo scopo del trattamento delle
					tue informazioni è che possiamo organizzare l&apos;evento e registrare la tua partecipazione e quella di
					eventuali accompagnatori per scopi amministrativi e per mantenere la sicurezza in relazione all&apos;evento.
				</p>
				<p>
					La nostra base giuridica per il trattamento è che possiamo perseguire il nostro legittimo interesse a ospitare
					eventi e soddisfare i vostri desideri e le vostre esigenze specifiche in relazione ai nostri eventi, cfr.
					articolo 6, paragrafo 1, lettera f) del Regolamento generale sulla protezione dei dati.
				</p>
				<p>
					Se trattiamo foto o video di te in relazione a uno dei nostri eventi, ciò si basa sul tuo consenso, che
					otteniamo se richiesto dalla legge, cfr. articolo 6, paragrafo 1, lettera a) del Regolamento generale sulla
					protezione dei dati. Si prega di notare che, per legge, in molti casi possiamo trattare immagini o video in
					cui l&apos;utente è incluso se si tratta di un&apos;immagine o di un video in cui l&apos;utente non è a fuoco,
					ad esempio se fa parte del pubblico di un evento.
				</p>
				<p>
					Chiediamo di non ricevere informazioni che rientrano nella categoria speciale di dati, cfr. articolo 9,
					paragrafo 1, del Regolamento generale sulla protezione dei dati, compresi i dati sanitari, le informazioni
					sulle convinzioni religiose o l&apos;appartenenza sindacale. Se comunque ci fornisci tali informazioni,
					presumiamo che tu abbia dato il tuo consenso esplicito al trattamento e quindi trattiamo queste informazioni
					sulla base del tuo consenso, cfr. articolo 6, paragrafo 1, lettera a) e articolo 9, paragrafo 2, lettera a)
					del Regolamento generale sulla protezione dei dati.
				</p>
				<h4 className="text-base underline md:text-lg">Le informazioni che trattiamo</h4>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>
						Informazioni di contatto: ad es. nome, indirizzo, e-mail, numero di telefono, codice postale, numero
						cliente, iniziali{" "}
					</li>
					<li>Informazioni relative al lavoro: ad es. titolo, posizione, luogo di lavoro </li>
					<li>Foto o video </li>
					<li>Altre informazioni fornite dall&apos;utente in relazione all&apos;evento</li>
					<li>
						Categorie particolari di dati, come le informazioni sulla tua salute o religione, religione o appartenenza
						sindacale, da te fornite in relazione alla tua partecipazione all&apos;evento{" "}
					</li>
				</ul>
				<h4 className="text-base underline md:text-lg">Conservazione delle informazioni dell&apos;utente</h4>
				<p>
					Di norma, conserviamo le tue informazioni per un massimo di 1 anno, a meno che non siamo obbligati a
					conservare le tue informazioni per un periodo più lungo nel paese in cui abbiamo tenuto l&apos;evento, o per
					tutto il tempo necessario per gestire qualsiasi questione relativa all&apos;evento, incluso per documentare i
					partecipanti all&apos;evento e rispondere alle tue richieste.
				</p>
				<h3 className="text-xl font-bold uppercase md:text-2xl">Se visiti una delle nostre sedi fisiche</h3>
				<p>
					Lo scopo del trattamento delle informazioni dell&apos;utente quando l&apos;utente è un visitatore di una delle
					nostre sedi è quello di garantire la sicurezza sia per il nostro bene che per quello dei nostri visitatori,
					nonché per indagare, prevenire e documentare incidenti e questioni penali.
				</p>
				<p>
					Inoltre, siamo obbligati a garantire la sicurezza dei processi che fanno parte della nostra produzione
					alimentare, ad esempio per rispettare la legislazione applicabile in materia di qualità e sicurezza
					alimentare.
				</p>
				<p>
					Abbiamo installato la videosorveglianza e la registrazione dell&apos;uso delle tessere di accesso in alcune
					delle nostre sedi.
				</p>
				<p>
					La base giuridica per il trattamento dei vostri dati è il nostro legittimo interesse a registrare i visitatori
					delle nostre sedi e a mantenere un certo livello di sicurezza, cfr. articolo 6, paragrafo 1, lettera f) del
					Regolamento generale sulla protezione dei dati.
				</p>
				<p>
					Chiediamo di non ricevere informazioni che rientrano nella categoria speciale di dati, cfr. articolo 9,
					paragrafo 1, del Regolamento generale sulla protezione dei dati, compresi i dati sanitari, le informazioni
					sulle convinzioni religiose o l&apos;appartenenza sindacale. Se comunque ci fornisci tali informazioni,
					presumiamo che tu abbia dato il tuo consenso esplicito al trattamento e quindi trattiamo queste informazioni
					sulla base del tuo consenso, cfr. articolo 6, paragrafo 1, lettera a) e articolo 9, paragrafo 2, lettera a)
					del Regolamento generale sulla protezione dei dati.
				</p>
				<h4 className="text-base underline md:text-lg">Le informazioni che trattiamo</h4>
				<p>Potremmo trattare le seguenti informazioni su di te come visitatore di una delle nostre sedi:</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>
						Informazioni di contatto: ad es. nome, indirizzo, e-mail, numero di telefono, codice postale, numero
						cliente, iniziali
					</li>
					<li>
						Informazioni relative al lavoro: ad es. titolo, posizione/anzianità, settore di lavoro, ID della tessera di
						accesso{" "}
					</li>
					<li>
						Altro documento d&apos;identità: ad esempio, la tua targa se hai utilizzato la nostra area di parcheggio
					</li>
					<li>
						Categorie particolari di dati, come i dati relativi alla salute, alla religione o all&apos;appartenenza
						sindacale, se forniti durante la visita.
					</li>
				</ul>
				<h4 className="text-base underline md:text-lg">Conservazione delle informazioni dell&apos;utente</h4>
				<p>
					Di norma, conserviamo le tue informazioni per un massimo di 1 anno, a meno che non siamo obbligati a
					conservare le tue informazioni per un periodo più lungo nel paese in cui hai visitato una delle nostre sedi, o
					per tutto il tempo necessario per gestire qualsiasi questione relativa alla tua visita, incluso per
					documentare la tua visita e rispondere alle tue richieste.
				</p>
				<p>
					La videosorveglianza viene conservata per un massimo di 30 giorni, dopodiché viene automaticamente cancellata.
				</p>
				<h3 className="text-xl font-bold uppercase md:text-2xl">
					Se ricevi comunicazioni di marketing o partecipi a un concorso di marketing
				</h3>
				<p>
					Lo scopo del trattamento dei dati dell&apos;utente quando riceve comunicazioni di marketing o partecipa a un
					concorso di marketing è che possiamo svolgere e gestire il marketing, compreso l&apos;invio di newsletter e lo
					svolgimento e la gestione di concorsi.
				</p>
				<p>
					Trattiamo inoltre le informazioni dell&apos;utente per garantire il rispetto della legislazione pertinente, ad
					esempio le leggi sulle pratiche di marketing applicabili nel paese in cui vengono svolte le attività di
					marketing, quando l&apos;utente riceve comunicazioni di marketing dei nostri prodotti o partecipa ai nostri
					concorsi.
				</p>
				<p>
					Ti invieremo informazioni sui prodotti, newsletter e altro materiale di marketing via e-mail solo se hai dato
					il tuo consenso preventivo ed esplicito a ciò, a meno che la legge applicabile non ci consenta di contattarti
					senza tale consenso. A questo proposito, ci assicuriamo di adempiere ai nostri obblighi legali di rispettare
					la legislazione sull&apos;acquisto e la commercializzazione dei nostri prodotti, cfr. articolo 6, paragrafo 1,
					lettera c) del Regolamento generale sulla protezione dei dati.
				</p>
				<p>
					Se partecipi a uno dei nostri concorsi e vinci un premio, potremmo rendere disponibili le tue informazioni e
					quelle dei tuoi potenziali ospiti sul nostro sito web o sulle nostre pagine di social media. Potremmo anche
					condividere le tue informazioni con terze parti, se necessario, per fornirti il tuo premio. La base giuridica
					per il trattamento in relazione ai concorsi a premi è generalmente l&apos;esecuzione di un contratto con
					l&apos;utente, cfr. articolo 6, paragrafo 1, lettera b) del Regolamento generale sulla protezione dei dati.
				</p>
				<p>
					Per le finalità di cui sopra, possiamo anche trattare le informazioni che l&apos;utente ha manifestamente
					pubblicato, ad esempio su una delle nostre pagine di social media, cfr. articolo 6, paragrafo 1, lettera f) e
					articolo 9, paragrafo 2, lettera e) del Regolamento generale sulla protezione dei dati.
				</p>
				<h4 className="text-base underline md:text-lg">Le informazioni che trattiamo</h4>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>
						Informazioni di contatto, ad es. nome, indirizzo, e-mail, numero di telefono, codice postale, numero
						cliente, iniziali
					</li>
					<li>
						Informazioni sui partecipanti: ad esempio, informazioni su di te e sui tuoi ospiti in relazione a un
						concorso a cui partecipi o che hai vinto
					</li>
					<li>Foto o video di te e dei tuoi potenziali ospiti</li>
					<li>Dati personali: Età</li>
					<li>
						Altre informazioni che l&apos;utente stesso ha fornito in relazione alla partecipazione a un concorso o
						simili.
					</li>
				</ul>
				<h4 className="text-base underline md:text-lg">Conservazione delle informazioni dell&apos;utente</h4>
				<p>
					Conserviamo le tue informazioni per un massimo di 2 anni, a meno che non siamo obbligati a conservare le tue
					informazioni per un periodo più lungo nel paese in cui hai ricevuto comunicazioni di marketing o partecipato a
					un concorso o per tutto il tempo necessario per gestire qualsiasi questione relativa al marketing o alla
					partecipazione a un concorso, inclusa la documentazione della tua partecipazione. Tuttavia, i dati possono
					essere elaborati e conservati più a lungo in forma anonima.
				</p>
				<p>
					Conserviamo la documentazione del tuo consenso alla legge sul marketing per 2 anni da quando hai revocato il
					tuo consenso a ricevere materiale di marketing diretto.
				</p>
				<h3 className="text-xl font-bold uppercase md:text-2xl">Se partecipi a ricerche di mercato o simili</h3>
				<p>
					Se partecipi a un&apos;indagine di mercato, a un questionario o simili, lo scopo è quello di comprenderti come
					cliente o consumatore. Trattiamo i tuoi dati per comprendere, calcolare o determinare la percezione dei nostri
					prodotti, di noi come fornitori o l&apos;efficacia dei nostri servizi, delle nostre prestazioni o del nostro
					marketing. Ciò ci consente di migliorare, tra le altre cose, i nostri prodotti, servizi, informazioni e
					marketing rivolti all&apos;utente e di ricevere consigli su prodotti e servizi.
				</p>
				<p>
					La nostra base giuridica per il trattamento è che possiamo perseguire il nostro legittimo interesse a
					garantire la qualità e il miglioramento dei nostri prodotti e servizi, nonché a offrirvi offerte e servizi
					pertinenti, cfr. articolo 6, paragrafo 1, lettera f) del Regolamento generale sulla protezione dei dati.
				</p>
				<p>
					Se richiesto dalla legge, prima di trattare i tuoi dati otteniamo il tuo consenso preventivo per contattarti
					in merito a ricerche di mercato, cfr. articolo 6, paragrafo 1, lettera a) del Regolamento generale sulla
					protezione dei dati.
				</p>
				<h4 className="text-base underline md:text-lg">Le informazioni che trattiamo:</h4>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>
						Informazioni di contatto: ad es. nome, indirizzo, e-mail, numero di telefono, codice postale, numero
						cliente, iniziali
					</li>
					<li>Informazioni relative al lavoro: ad es. titolo, posizione, luogo di lavoro </li>
				</ul>
				<h4 className="text-base underline md:text-lg">Conservazione delle informazioni dell&apos;utente</h4>
				<p>Come punto di partenza, conserviamo le tue informazioni per un massimo di 5 anni.</p>
				<p>
					Conserviamo le tue informazioni solo per il tempo in cui è legale e per tutto il tempo necessario per essere
					in grado di rispondere a qualsiasi tua richiesta. Tuttavia, le informazioni possono essere elaborate e
					conservate più a lungo in forma anonima.
				</p>
				<h3 className="text-xl font-bold uppercase md:text-2xl">Se ti stai candidando per un lavoro</h3>
				<p>
					Se ti candidi per un posto di lavoro, devi creare un profilo nel nostro sistema di reclutamento, dove puoi
					anche leggere di più sul trattamento dei tuoi dati in relazione al reclutamento nella nostra informativa
					separata sui dati personali per i candidati, che puoi trovare nel sistema di reclutamento.
				</p>
				<p>
					Se l&apos;utente è un candidato per una posizione, lo scopo del trattamento delle informazioni che lo
					riguardano è quello di valutare se l&apos;utente è un candidato qualificato per una posizione vacante.
					Registriamo anche le tue informazioni per documentare la tua candidatura dopo che il processo di reclutamento
					è stato completato.
				</p>
				<p>
					La nostra base giuridica per il trattamento dei dati personali è la richiesta da parte dell&apos;utente di
					elaborare la sua candidatura e il suo CV prima dell&apos;eventuale stipula di un contratto di lavoro, cfr.
					articolo 6, paragrafo 1, lettera b) del Regolamento generale sulla protezione dei dati.
				</p>
				<p>
					In caso di assunzione, memorizziamo le informazioni che hanno fatto parte del processo di reclutamento nella
					cartella del personale.
				</p>
				<h3 className="text-xl font-bold uppercase md:text-2xl">
					Se l&apos;utente è coperto dalle nostre attività di conformità, anticrimine o simili
				</h3>
				<p>
					Il titolare del trattamento dei dati personali raccolti nell&apos;ambito del nostro programma di segnalazione
					è Royal Unibrew A/S.
				</p>
				<p>
					Lo scopo del trattamento dei dati dell&apos;utente in relazione alle nostre attività di conformità,
					anticrimine o simili è quello di poter:
				</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>
						Verificare che le nostre transazioni e i nostri rapporti, anche con partner commerciali e terze parti, siano
						conformi alla legge applicabile e alle nostre linee guida etiche e assicurarci di avere solo partner
						commerciali e fornitori che soddisfano questi standard
					</li>
					<li>
						Garantire la conformità alle nostre politiche, procedure, linee guida e standard se l&apos;utente utilizza i
						nostri servizi o visita luoghi fisici
					</li>
					<li>Garantire la qualità dei nostri prodotti e servizi </li>
					<li>
						Contribuire alla lotta contro la criminalità, compresa la frode, e per stabilire, difendere o far valere un
						diritto in sede giudiziaria.{" "}
					</li>
					<li>
						Gestisci e fai funzionare il nostro portale per gli informatori. Se hai segnalato un caso in modo anonimo,
						non avremo accesso alle tue informazioni.
					</li>
				</ul>
				<p>
					Il trattamento dei vostri dati è necessario per il perseguimento dei nostri legittimi interessi nelle finalità
					di cui sopra e per garantire la documentazione dell&apos;adempimento, cfr. articolo 6, paragrafo 1, lettera f)
					del Regolamento generale sulla protezione dei dati.
				</p>
				<p>
					In alcuni casi, siamo obbligati a trattare le informazioni per rispettare la legislazione antiriciclaggio o
					altre leggi, cfr. articolo 6, paragrafo 1, lettera c) del Regolamento generale sulla protezione dei dati.
				</p>
				<p>
					Inoltre, possiamo trattare i vostri dati per stabilire, difendere o far valere un diritto in sede giudiziaria,
					cfr. articolo 6, paragrafo 1, lettera f) o articolo 9, paragrafo 2, lettera f) del Regolamento generale sulla
					protezione dei dati.
				</p>
				<h4 className="text-base underline md:text-lg">Le informazioni che trattiamo</h4>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>
						Informazioni di contatto: ad es. nome, indirizzo, e-mail, numero di telefono, codice postale, numero
						cliente, iniziali, nonché informazioni su di te e su eventuali accompagnatori in relazione a un evento,
						concorso, sondaggio o simili a cui hai partecipato.
					</li>
					<li>
						Informazioni relative al lavoro: ad es. titolo, posizione/anzianità, settore di lavoro, ID della carta di
						ammissione
					</li>
					<li>
						Informazioni sul documento d&apos;identità: numero di identificazione personale, informazioni sulla patente
						di guida, informazioni sul passaporto
					</li>
					<li>
						Altro documento d&apos;identità: ad esempio, la tua targa se hai utilizzato la nostra area di parcheggio
					</li>
					<li>
						Informazioni finanziarie: informazioni sul conto bancario, informazioni sulle transazioni, cronologia degli
						acquisti
					</li>
					<li>Foto e video, ad es. di un evento</li>
					<li>
						Categorie speciali di dati, come informazioni sulla vostra salute, religione o appartenenza sindacale, che
						ci avete fornito nel corso di un&apos;interazione con noi{" "}
					</li>
					<li>
						Impronte digitali: &quot;impronta digitale&quot; del browser, &quot;impronta digitale&quot; dei dispositivi,
						indirizzo IP, indirizzo MAC, sistema operativo, informazioni sulla posizione, cronologia di navigazione, ID
						utente/nome di accesso, password, soprannomi online, profili di social media, nomi voIP (ad esempio, nome
						skype), registri, ID dispositivo (ad esempio, IMEI, ICCID, IMSI)
					</li>
					<li>Altre informazioni incluse in una segnalazione effettuata sul portale degli informatori </li>
					<li>Cookie (Per saperne di più sull&apos;uso dei cookie, consultare la sezione seguente)</li>
				</ul>
				<h4 className="text-base underline md:text-lg">Conservazione delle informazioni dell&apos;utente</h4>
				<p>
					Non conserviamo le informazioni più a lungo di quanto sia necessario per soddisfare lo scopo. Il periodo
					durante il quale conserviamo le informazioni dell&apos;utente sarà determinato in modo specifico a seconda del
					caso in cui le informazioni sono incluse. Il periodo dipende, tra l&apos;altro, dalla base su cui vengono
					trattati i tuoi dati.
				</p>
				<p>
					Cancelliamo le informazioni non appena il caso in cui sono incluse le informazioni è stato chiuso, a meno che
					le informazioni non siano incluse in altri casi o siano state raccolte per altri scopi, dopodiché possiamo
					conservare le informazioni più a lungo.
				</p>
				<p> </p>
				<h2 className="text-2xl font-bold uppercase md:text-3xl">Condivisione dei dati personali</h2>
				<p>
					Potremmo condividere i tuoi dati personali con i nostri fornitori e partner se necessario per adempiere ai
					nostri obblighi nei tuoi confronti. I fornitori e i partner possono essere, ad esempio, fornitori di beni o
					servizi (ad esempio, in relazione alla consegna di un ordine all&apos;utente), fornitori IT e fornitori di
					sistemi IT.
				</p>
				<p>
					In relazione alle visite ai nostri siti web, all&apos;utilizzo di altri servizi digitali offerti dal Gruppo o
					alla partecipazione a eventi e alla ricezione di altro materiale di marketing, potremmo anche condividere le
					informazioni dell&apos;utente con società di hosting, fornitori di sistemi di prenotazione, fornitori di
					servizi di marketing e altri fornitori di servizi necessari per soddisfare tali scopi. Tali fornitori di
					servizi tratteranno i dati personali in conformità con le nostre istruzioni ai sensi degli accordi sul
					trattamento dei dati firmati.
				</p>
				<p>
					Le informazioni possono essere necessarie per adempiere ai nostri obblighi ai sensi della legge o per
					proteggere i diritti, la proprietà o la sicurezza nostri o di altri. In questi casi, potremmo divulgare
					informazioni ad autorità pubbliche, revisori dei conti, avvocati o altri consulenti.
				</p>
				<p>
					In alcuni casi, divulghiamo i dati dell&apos;utente ad altre società del Gruppo allo scopo di analizzare,
					sviluppare e gestire la nostra attività, nonché nei casi in cui i nostri servizi sono condivisi tra le nostre
					società.
				</p>
				<p>
					In relazione allo sviluppo del Gruppo, la struttura societaria può cambiare, ad esempio mediante il
					trasferimento di tutte o parte delle attività. In caso di trasferimento di parti dell&apos;attività o di altre
					modifiche commerciali, la base giuridica per la relativa divulgazione dei dati personali è generalmente il
					nostro legittimo interesse in questo caso.
				</p>
				<p>
					Se trasferiamo informazioni a terzi al di fuori dell&apos;UE e/o del SEE, siamo obbligati a prendere
					precauzioni speciali per garantire che le tue informazioni siano protette. Garantiremo sempre un livello
					adeguato di protezione dei dati e una base giuridica per il trasferimento dei vostri dati, ad esempio
					utilizzando le clausole contrattuali standard (SCC) dell&apos;UE.
				</p>
				<p>Puoi contattarci in qualsiasi momento per ulteriori informazioni su chi condivide le tue informazioni.</p>
				<h2 className="text-2xl font-bold uppercase md:text-3xl">Consenso</h2>
				<p>
					Nei casi in cui trattiamo le tue informazioni sulla base del tuo consenso, puoi sempre revocare il tuo
					consenso. Se ritiri il tuo consenso, interromperemo il trattamento delle tue informazioni a meno che non
					abbiamo il diritto o l&apos;obbligo di continuare a trattare o archiviare le tue informazioni per altri
					motivi, anche in conformità con la legge.
				</p>
				<p>La revoca del consenso non pregiudica la liceità del trattamento basata sul consenso prima della revoca.</p>
				<p>Puoi revocare il tuo consenso in qualsiasi momento:</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>Come contattarci (vedi i dettagli di contatto di seguito)</li>
					<li>Eliminazione del profilo nei casi in cui è stato creato un profilo</li>
					<li>
						Il consenso ai cookie può essere revocato come descritto nella cookie policy del sito web che si sta
						visitando
					</li>
				</ul>
				<p>
					Se ritiri il tuo consenso, potresti non essere in grado di utilizzare appieno le funzionalità che offriamo sui
					nostri siti web.
				</p>
				<h2 id="cookies" className="text-2xl font-bold uppercase md:text-3xl">
					Cookies
				</h2>
				<p>
					Utilizziamo i cookie sui nostri siti web. Per saperne di più sull&apos;utilizzo dei cookie, consultare
					l&apos;informativa sui cookie, disponibile e aggiornata in qualsiasi momento tramite un link sul sito web che
					si sta visitando.
				</p>
				<h2 className="text-2xl font-bold uppercase md:text-3xl">I tuoi diritti</h2>
				<p>
					Secondo la legge, con alcune eccezioni, l&apos;utente gode di determinati diritti in relazione al trattamento
					dei suoi dati da parte nostra:
				</p>
				<ul className="list-outside list-disc pl-4 md:pl-8">
					<li>L&apos;utente ha il diritto di ottenere informazioni sulle informazioni che trattiamo su di lui</li>
					<li>
						L&apos;utente può opporsi alla raccolta e all&apos;ulteriore trattamento dei propri dati da parte nostra
					</li>
					<li>
						L&apos;utente ha il diritto di richiedere la correzione o la cancellazione dei propri dati, fatte salve
						alcune eccezioni previste dalla legge{" "}
					</li>
					<li>L&apos;utente ha il diritto di chiederci di limitare il trattamento</li>
					<li>
						In alcuni casi, l&apos;utente ha il diritto di ricevere le informazioni che abbiamo registrato su di lui e
						di richiederci di trasferire tali dati a un altro titolare del trattamento (portabilità dei dati)
					</li>
					<li>
						Se trattiamo i tuoi dati sulla base del &quot;nostro legittimo interesse&quot;, puoi opporti al trattamento
						su questa base
					</li>
				</ul>
				<p>I tuoi diritti potrebbero essere limitati nel paese in cui vivi.</p>
				<p>
					Se desideri esercitare i tuoi diritti, ti preghiamo di contattarci (vedi i dettagli di contatto di seguito).
					In relazione alle richieste relative ai tuoi diritti, ti chiediamo di fornirci informazioni sufficienti per
					consentirci di elaborare la tua richiesta, incluso il fatto che ci consenti di identificarti in relazione
					all&apos;oggetto della tua richiesta.
				</p>
				<h2 className="text-2xl font-bold uppercase md:text-3xl">Riferimenti ad altri siti web, ecc.</h2>
				<p>
					I nostri siti web possono contenere link ad altri siti web. Non siamo responsabili per il contenuto di altri
					siti web (siti web di terze parti) o per le procedure che tali terze parti hanno per la raccolta e
					l&apos;elaborazione delle informazioni. Quando visiti un sito Web di terze parti, dovresti leggere
					l&apos;informativa sulla privacy del proprietario del sito Web e altre politiche pertinenti.
				</p>
				<h2 className="text-2xl font-bold uppercase md:text-3xl">Contattaci</h2>
				<p>
					Se desideri esercitare i tuoi diritti o se hai domande sul trattamento dei tuoi dati, puoi contattarci via
					e-mail all&apos;indirizzo:{" "}
					<a href="mailto:GDPR@Royalunibrew.com" target="_blank" rel="noopener noreferrer" className="underline">
						GDPR@Royalunibrew.com
					</a>
					.
				</p>
				<p>
					Puoi anche sempre contattare la tua azienda locale sotto il gruppo Royal Unibrew Group. Puoi trovare un elenco
					di tutte le aziende e sedi di Royal Unibrew qui{" "}
					<a
						href="https://www.royalunibrew.com/about-us/company-structure"
						target="_blank"
						rel="noopener noreferrer"
						className="underline">
						https://www.royalunibrew.com/about-us/company-structure
					</a>
				</p>
				<h2 className="text-2xl font-bold uppercase md:text-3xl">Lamentele</h2>
				<p>
					Se non sei d&apos;accordo con il modo in cui trattiamo le tue informazioni o con le finalità per le quali le
					trattiamo, puoi contattarci all’indirizzo:{" "}
					<a href="mailto:GDPR@Royalunibrew.com" target="_blank" rel="noopener noreferrer" className="underline">
						GDPR@Royalunibrew.com
					</a>
					.
				</p>
				<p>
					È inoltre possibile presentare un reclamo all&apos;autorità locale per la protezione dei dati. Una panoramica
					delle autorità di protezione dei dati nell&apos;UE è disponibile qui:{" "}
					<a
						href="https://edpb.europa.eu/about-edpb/about-edpb/members_en"
						target="_blank"
						rel="noopener noreferrer"
						className="underline">
						https://edpb.europa.eu/about-edpb/about-edpb/members_en
					</a>
				</p>
				<h2 className="text-2xl font-bold uppercase md:text-3xl">Modifiche all&apos;Informativa sulla privacy</h2>
				<p>
					Ci riserviamo il diritto di modificare la presente informativa sulla privacy in caso di modifiche
					significative della legislazione o a seguito di modifiche nelle nostre attività di trattamento.
				</p>
			</div>
		</main>
	);
};

export default PrivacyPolicy;
